import NotificationSetting from 'features/profile/components/notification-setting';
import { SettingsContentHeader } from 'components/layouts/settings-workspace/settings-workspace';
import { SettingsDataSection } from 'components/layouts/settings-workspace/settings-data-section';
import { immediateToast } from 'utils/toast';
import HelmetTabComponent from 'components/helmet-tab/helmet-tab';

type ProfileNotification = {
    name: string;
    label: string;
};

const notifications: ProfileNotification[] = [
    {
        name: 'auth',
        label: 'ورود به حساب کاربری',
    },
    {
        name: 'answer-ticket',
        label: 'پاسخ و دریافت تیکت',
    },
    {
        name: 'marketing-withdraw',
        label: 'تسویه حساب بازاریابی',
    },
];

type NotificationToggleRequest = {
    name: string;
    service: string;
    status: boolean;
};

type NotificationToggleResponse = {
    data?: Record<string, unknown>;
    errors?: Record<string, string[]>;
};

const UNEXPECTED_ERROR_MESSAGE = 'خطای غیر منتظره رخ داده است';
const TOAST_TIMEOUT = 3000;

const showServerFieldErrors = (data?: Record<string, string[]>) => {
    Object.values(data ?? {}).forEach((messages) => {
        immediateToast('error', {
            message: messages[0] ?? UNEXPECTED_ERROR_MESSAGE,
            timeout: TOAST_TIMEOUT,
        });
    });
};

const handleResponse = (res: unknown, data: NotificationToggleRequest) => {
    const response = (res ?? {}) as NotificationToggleResponse;

    if (response.errors) {
        showServerFieldErrors(response.errors);
        return;
    }

    const notification = notifications.find((n) => n.name === data.name);

    immediateToast('success', {
        message: `اطلاع رسانی ${data?.service} برای ${notification?.label} ${
            data?.status ? 'فعال' : 'غیرفعال'
        } شد`,
        timeout: TOAST_TIMEOUT,
    });
};

const NotificationsTab = () => {
    return (
        <>
            <HelmetTabComponent title="تنظیمات اطلاع‌رسانی" />

            <SettingsContentHeader
                title="تنظیمات اطلاع‌رسانی"
                description="کانال‌های اطلاع‌رسانی رویدادهای حساب کاربری را انتخاب کنید."
            />

            <SettingsDataSection>
                <NotificationSetting
                    url={`${import.meta.env.VITE_APP_API_URL}notifications`}
                    notifications={notifications}
                    onResponse={handleResponse}
                    noCard
                    animationVariant="settings"
                />
            </SettingsDataSection>
        </>
    );
};

export default NotificationsTab;
